<div id="{{ id }}" class="bespoke-slide {{ classes }}">
    <div class="scroll">
        <div class="scroll__text">Scroll or use your keyboard to continue</div>
    </div>
        {{#if slide.title}}
            <h2>{{ slide.title }}</h2>
        {{/if}}

        {{#if slide.bg_img}}
            <div class="media-outer">
                <img src="{{slide.bg_img}}" alt="" />
            </div>
        {{/if}}

        {{#if slide.text}}
            <div>{{ slide.text }}</div>
        {{/if}}

        {{#if slide.text_list}}
            <div class="slide__bullet-group">
                {{#each slide.text_list as text_item, n}}
                    <div class="slide__text slide__text--{{ n + 1 }} step">
                        <div class="slide__text-outer">
                            {{#if text_item.type == 'Text'}}
                                <p class="slide__text-inner">{{ text_item.text }}</p>
                            {{elseif text_item.type == 'Video' }}
                                <Modal slideIndex={{i}} modalIndex={{n}} modal={{text_item}} />
                            {{elseif text_item.type == 'Aside' }}
                                <Modal slideIndex={{i}} modalIndex={{n}} modal={{$science_asides[text_item.slug]}} />
                            {{else}}
                                <p class="slide__text-inner">{{ text_item }}</p> 
                            {{/if}}
                        </div>
                    </div>
                {{/each}}
                <span class="slide__text-bg"></span>
            </div>
        {{/if}}
</div>

<script>
import Modal from './Modal.html'
export default {

    components: {
        Modal,
    },

    data() {
        return {
            slide: {},
            i: 0,
        }
    },

    computed: {
        id: slide => slide.slug ? slide.slug : slide._id,
        classes: ($current_slide, i) => {
            let classes = i == $current_slide ? 'bespoke-active' : 'bespoke-inactive';
            if (i < $current_slide) classes += ' bespoke-before'; 
            if (i > $current_slide) classes += ' bespoke-after';
            return classes;
        }
    },
}
</script>